import React, { memo } from 'react';
import { NO_DATA } from 'assets/icons';
import PropTypes from 'prop-types';
import Img from '../Img/index';
import * as Styled from './styles';

const NoData = ({ descriptionText }) => {
  return (
    <Styled.Wrapper>
      <Styled.Inner>
        <Img src={NO_DATA} sizes={[35, 35]} />
        <Styled.Text>{descriptionText}</Styled.Text>
      </Styled.Inner>
    </Styled.Wrapper>
  );
};

NoData.propTypes = {
  descriptionText: PropTypes.string,
};

NoData.defaultProps = {
  descriptionText: 'No data',
};

export default memo(NoData);
